export default "__VITE_ASSET__CHwqBEoe__"